import { Theme } from '@mui/material';
import { AccumFullIcon, AccumPartialIcon } from '../Icons';
import { icon } from './vehicleBatteryBadge.style';

export const getColorConfig = (theme: Theme, isLow?: boolean) => {
  if (isLow) {
    return {
      borderColor: theme.palette.low?.border,
      backgroundColor: theme.palette.low?.background,
      color: theme.palette.low?.text,
      icon: <AccumPartialIcon sx={() => icon(theme.palette.low?.fill)} />,
    };
  }

  return {
    borderColor: theme.palette.normal?.border,
    backgroundColor: theme.palette.normal?.background,
    color: theme.palette.normal?.text,
    icon: <AccumFullIcon sx={() => icon(theme.palette.normal?.fill)} />,
  };
};
